export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-a1c4ad34a6c536ffdc3484a33d0955f0.woff2";